import { renderRoutes } from 'react-router-config';
import { getRoutes, RFC } from 'configs/navigation';

const Activities: RFC = ({ route }) => {
  return renderRoutes(getRoutes(route));
};

export default Activities;
